(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-action"] && !Shopify.designMode) return;
  try {
    let calendlyLoading;
document.addEventListener('click', async (event) => {
  const link = event.target.closest('a[data-ma-booking]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  if (url.protocol !== 'https:' || url.hostname !== 'calendly.com') return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  link.setAttribute('aria-busy', 'true');
  try {
    if (!window.Calendly) {
      calendlyLoading ||= new Promise((resolve, reject) => {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://assets.calendly.com/assets/external/widget.css';
        document.head.append(css);
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        const timeout = setTimeout(() => reject(new Error('Calendly timeout')), 8000);
        script.onload = () => { clearTimeout(timeout); resolve(); };
        script.onerror = () => { clearTimeout(timeout); reject(new Error('Calendly unavailable')); };
        document.head.append(script);
      });
      await calendlyLoading;
    }
    link.closest('dialog')?.close();
    window.Calendly.initPopupWidget({ url: url.href });
  } catch {
    window.location.assign(url.href);
  } finally {
    link.removeAttribute('aria-busy');
  }
});
  } catch(e) { console.error(e); }
})();

})();
